import { AxiosResponse } from "axios";
import { apiNode } from "./api";

import { DefaultGetParamsProps } from "./types/interfaces";
import { GetTaskStatusResponse } from "./types/task.interfaces";

const URL_TASKS = "2/tasks/v2/tasks";

export const TaskService = {
	async getTaskStatus({
		id,
	}: DefaultGetParamsProps): Promise<GetTaskStatusResponse> {
		const response: AxiosResponse<GetTaskStatusResponse> = await apiNode.get(
			`${URL_TASKS}/${id}`
		);
		return response?.data;
	},
	async cancelDownload({ taskId }: { taskId: string }) {
		const response = await apiNode.post(
			`2/file-system/download/cancel/${taskId}`,
			{}
		);
		return response?.data;
	}
};
